import { CartService, CartServiceModule } from '@b2b/common/services';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular from 'angular';

OrderOrganizationDirective.$inject = ['$state', 'AddressService', 'ApiService', 'HelpersService', 'CartService'];
function OrderOrganizationDirective(
  $state: StateService,
  AddressService: AddressService,
  ApiService: TODO,
  HelpersService: TODO,
  CartService: CartService
) {
  OrderOrganizationController.$inject = ['$scope', '$uibModal'];
  function OrderOrganizationController($scope, $uibModal) {
    const ctrl = {
      model: {},
      selectedOrganization: null as any | null,
      organizationsList: [],
      isLoaded: true,

      init: function () {
        this.setModel();
        $scope.$on('$destroy', $scope.$watch('orderOrganization.selectedOrganization', this.onOrganizationChange));
      },

      setModel: function () {
        this.model = CartService.getOrganization() || {};
        if (this.model && this.model.id) {
          this.model.address = AddressService.createAddress(this.model);
          this.selectedOrganization = this.model;
        }
      },

      searchOrganizations: function (searchText) {
        const props = HelpersService.getPaginator();
        props.withAddress = '1';
        props.pageSize = 8;

        if (!searchText && !this.isLoaded) {
          this.resetSelection();
          this.isLoaded = true;
          ApiService.organizations
            .listTransactable(props)
            .then(this.success.searchOrganizations, this.error.searchOrganizations);
        } else {
          props.search = searchText;
          ApiService.organizations
            .listTransactable(props)
            .then(this.success.searchOrganizations, this.error.searchOrganizations);
        }
      },

      resetSelection: function (force = false) {
        if (force || this.model.id) {
          this.organizationsList = this.processOrganizations([this.model]);
          this.selectedOrganization = this.organizationsList[0];
        } else {
          this.organizationsList = [];
          this.selectedOrganization = null;
          CartService.updateOrganization();
          CartService.cancelCart();
        }
      },

      updateOrganization: function () {
        const showPrompt = !HelpersService.isEmptyObject(ctrl.model) && !this.selectedOrganization;
        let message;

        if (showPrompt) {
          message =
            'Do you want to remove ' +
            HelpersService.getFullName(this.model) +
            ' from the order?' +
            '<br><br>Doing so will remove any items in the cart.';

          this.showMessage(
            'Are you sure?',
            message,
            'Continue',
            function (response) {
              ctrl.model = {};
              ctrl.resetSelection();
            },
            function () {
              if (ctrl.model) {
                ctrl.selectedOrganization = ctrl.model;
              } else if (!ctrl.selectedOrganization) {
                ctrl.resetSelection();
              }
            }
          );
        } else {
          this.updateOrganizationAndProceed();
        }
      },

      updateOrganizationAndProceed: function () {
        if (!this.selectedOrganization && !HelpersService.isEmptyObject(this.model)) {
          this.resetSelection();
        } else {
          CartService.updateOrganization(this.selectedOrganization);
          this.setModel();
        }
      },

      showMessage: function (title, message, okText, successCallback, errorCallback) {
        if (message) {
          const showMessageModal = $uibModal.open({
            size: 'md',
            controller: 'ConfirmModalController',
            templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
            resolve: {
              modalTitle: function () {
                return title;
              },
              modalMessage: function () {
                return message;
              },
              okText: function () {
                return okText || 'Done';
              },
              cancelText: function () {
                return null;
              },
            },
          });
          // Invoked when modal completes with close(params)
          showMessageModal.result.then(
            function () {
              if (typeof successCallback === 'function') {
                successCallback();
              }
            },
            function () {
              // Do nothing
              if (typeof errorCallback === 'function') {
                errorCallback();
              }
            }
          );
        }
      },

      success: {
        searchOrganizations: function (response) {
          ctrl.organizationsList = response.data.payload.list;
          if (!ctrl.isLoaded) {
            ctrl.selectedOrganization = ctrl.organizationsList[0];
          } else {
            $scope.$broadcast('CustomTypeahead::FilterResults', {
              field: 'combobox-input-' + 'order-organization-search',
            });
          }

          ctrl.isLoaded = true;
        },
      },

      error: {
        searchOrganizations: function () {
          ctrl.organizationsList = [];
          ctrl.isLoaded = true;
        },
      },

      onOrganizationChange: function (e, data) {
        ctrl.updateOrganization();
      },

      onBlur: function () {
        ctrl.resetSelection();
      },
    };

    $scope.orderOrganization = ctrl;
    $scope.orderOrganization.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/organization/organization.tpl.html',
    scope: {},

    link: function ($scope, $element, $attrs, ngModelCtrl) {},

    controller: OrderOrganizationController,
  };
}

export const OrderOrganizationDirectiveModule = angular
  .module('acme.common.directive.order.organization', [
    AddressServiceModule,
    'acme.common.service.api',
    'acme.common.service.helpers',
    CartServiceModule,
    'acme.common.directive.orgSearch',
    'ui.bootstrap',
  ])
  .directive('organization', OrderOrganizationDirective).name;
